import script from "./TextQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TextQuestion.vue?vue&type=script&setup=true&lang=js"

import "./TextQuestion.vue?vue&type=style&index=0&id=3db99516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db99516"]])

export default __exports__